import { useMemo } from 'react';
import { useGetOfferQuery } from '../api';
import { offerDetailsTransformer } from '../helpers';
import { OfferDetails } from '../types';
import { skipToken } from '@reduxjs/toolkit/query';

export function useOfferDetails(id?: string | null): OfferDetails | null {

  const queryArgs = id ? { id } : skipToken;

  const { data: offer } = useGetOfferQuery(queryArgs);

  return useMemo(() => {
    if (!offer) return null;
    return offerDetailsTransformer(offer);
  }, [offer]);
}
